// src/Lexburner/MyStuff.jsx
import React, { useState, useEffect } from 'react';

export default function MyStuff() {
  const [rented, setRented] = useState([]);
  const [available, setAvailable] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  // Fetch both lists
  useEffect(() => {
    async function load() {
      setLoading(true);
      try {
        const [rRes, aRes] = await Promise.all([
          fetch('/api/numbers/rented'),
          fetch('/api/numbers/available'),
        ]);
        if (!rRes.ok || !aRes.ok) throw new Error('Fetch failed');
        setRented(await rRes.json());
        setAvailable(await aRes.json());
      } catch (err) {
        console.error(err);
        setError('Unable to load number lists');
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  // Helper to refresh after an action
  const refresh = () => {
    setLoading(true);
    setError(null);
    fetch('/api/numbers/rented')
      .then(res => res.json()).then(setRented);
    fetch('/api/numbers/available')
      .then(res => res.json()).then(setAvailable)
      .finally(() => setLoading(false));
  };

  // Rent or renew (same endpoint; renew will just extend expiry)
  const handleRent = async (number) => {
    try {
      const res = await fetch('/api/numbers/rent', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ number }),
      });
      if (!res.ok) throw new Error('Failed to rent number');
      refresh();
    } catch (err) {
      console.error(err);
      setError(err.message);
    }
  };

  // Release
  const handleRelease = async (number) => {
    try {
      const res = await fetch('/api/numbers/release', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ number }),
      });
      if (!res.ok) throw new Error('Failed to release number');
      refresh();
    } catch (err) {
      console.error(err);
      setError(err.message);
    }
  };

  if (loading) return <div className="my-stuff-page"><p>Loading…</p></div>;

  return (
    <div className="my-stuff-page">
      <h2>Number Management</h2>
      {error && <p style={{ color: '#ff6b6b' }}>{error}</p>}

      {/* Currently Rented */}
      <section className="rented-section">
        <h3>Currently Rented</h3>
        {rented.length === 0
          ? <p>No rented numbers</p>
          : (
            <ul className="rented-list">
              {rented.map(r => (
                <li key={r.number}>
                  <div className="num">{r.number}</div>
                  <div className="meta">
                    <span>Region: {r.region}</span>
                    <span>Expires: {r.expires}</span>
                  </div>
                  <button
                    className="btn-small"
                    onClick={() => handleRent(r.number)}
                  >
                    Renew
                  </button>
                  <button
                    className="btn-small btn-release"
                    onClick={() => handleRelease(r.number)}
                  >
                    Release
                  </button>
                </li>
              ))}
            </ul>
          )
        }
      </section>

      {/* Available to Rent */}
      <section className="available-section">
        <h3>Rent New Number</h3>
        {available.length === 0
          ? <p>No numbers available</p>
          : (
            <ul className="available-list">
              {available.map(n => (
                <li key={n.number}>
                  <div className="num">{n.number}</div>
                  <div className="meta">
                    <span>${n.price} / month</span>
                    {n.premiumSurcharge > 0 &&
                      <span>Surcharge: ${n.premiumSurcharge}</span>}
                  </div>
                  <button
                    className="btn-small"
                    onClick={() => handleRent(n.number)}
                  >
                    Rent
                  </button>
                </li>
              ))}
            </ul>
          )
        }
      </section>
    </div>
  );
}
